<script lang="ts">
	import { Button } from '@Shelly/shelly-design-system';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { HOMES_WHATS_NEW_KEY } from 'src/helpers/homes-onboarding-helper';

	const resetHomesOnboarding = () => {
		save_profile(HOMES_WHATS_NEW_KEY, 1680455849);
	};
</script>

<Button on:click={resetHomesOnboarding}>Reset Homes Onboarding</Button>
